import React from 'react'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles'
import {
  Button,
  CircularProgress,
  useMediaQuery,
  ButtonProps,
} from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
  addToCartButton: {
    minWidth: theme.typography.pxToRem(136),
  },
  loadingIcon: {
    position: 'absolute',
    top: '10%',
    left: '50%',
    marginLeft: '-20px',
    zIndex: 1,
  },
  addToCartLoading: {
    color: theme.palette.primary.main,
  },
}))

export enum Variants {
  Contained = 'contained',
  Outlined = 'outlined',
}

export enum Colors {
  Primary = 'primary',
  Secondary = 'secondary',
}

interface DiscoPromoAddToCartButtonProps {
  dirty: boolean
  isSubmitting: boolean
  handleAddToCart?: (e?) => void
  addToCartButtonClass?: string
  variant?: Variants
  color?: Colors
  fullWidth?: boolean
  isAddToList?: boolean
  disabled?: boolean
  size?: ButtonProps['size']
}

const DiscoPromoAddToCartButton: React.FC<DiscoPromoAddToCartButtonProps> = ({
  size,
  variant,
  color,
  isSubmitting,
  fullWidth,
  handleAddToCart,
  addToCartButtonClass,
  dirty,
  disabled,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isDesktop =
    useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true }) === true
  return (
    <Button
      size={size || (isDesktop ? 'medium' : 'large')}
      type="submit"
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      disabled={isSubmitting || !dirty || disabled}
      onClick={handleAddToCart}
      className={addToCartButtonClass || classes.addToCartButton}
      data-testid="add-to-cart-button"
      id="add-to-cart-button"
    >
      {isSubmitting && (
        <CircularProgress
          size={30}
          className={clsx(classes.addToCartLoading, classes.loadingIcon)}
        />
      )}
      <FormattedMessage id="ADD_TO_CART" defaultMessage="Add to Cart" />
    </Button>
  )
}

export default DiscoPromoAddToCartButton
